type BroadcastPayload = {
  type: string;
  data: unknown;
  ts: number;
};

const CHANNEL_NAME = 'scrambl-realtime-sync';

let channel: BroadcastChannel | null = null;
const listeners = new Map<string, Set<(data: unknown) => void>>();

function ensureChannel(): BroadcastChannel | null {
  if (typeof window === 'undefined') return null;
  if (typeof BroadcastChannel === 'undefined') return null;
  if (!channel) {
    channel = new BroadcastChannel(CHANNEL_NAME);
    channel.addEventListener('message', (event: MessageEvent) => {
      const msg = event.data as BroadcastPayload;
      const subs = listeners.get(msg.type);
      if (subs) subs.forEach((fn) => fn(msg.data));
    });
  }
  return channel;
}

export function postMessage(type: string, data: unknown) {
  const ch = ensureChannel();
  const payload: BroadcastPayload = { type, data, ts: Date.now() };
  if (ch) {
    ch.postMessage(payload);
    return;
  }
  // Fallback to localStorage if BroadcastChannel is unavailable
  try {
    localStorage.setItem(type, JSON.stringify(payload));
  } catch {
    // ignore
  }
}

export function addListener(type: string, handler: (data: unknown) => void) {
  const ch = ensureChannel();
  if (ch) {
    const set = listeners.get(type) || new Set();
    set.add(handler);
    listeners.set(type, set);
    return () => {
      const subs = listeners.get(type);
      if (subs) {
        subs.delete(handler);
        if (subs.size === 0) listeners.delete(type);
      }
    };
  }
  // Fallback listener via localStorage
  const storageHandler = (e: StorageEvent) => {
    if (e.key !== type || !e.newValue) return;
    try {
      const payload = JSON.parse(e.newValue) as BroadcastPayload;
      handler(payload.data);
    } catch {
      // ignore
    }
  };
  window.addEventListener('storage', storageHandler);
  return () => window.removeEventListener('storage', storageHandler);
}


